var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldText, FieldTextarea, FlexBox, } from '@dixa/lib-shared-habla';
import * as React from 'react';
import styles from './charLimitFieldText.module.scss';
export function CharLimitFieldText(_a) {
    var { maxLength, inputType, wrapperStyle, input } = _a, props = __rest(_a, ["maxLength", "inputType", "wrapperStyle", "input"]);
    if (maxLength < 1) {
        throw new Error(`maxLength values expected to be >= 1, actual: ${maxLength}`);
    }
    let Input;
    switch (inputType) {
        case 'text':
            Input = FieldText;
            break;
        case 'textarea':
            Input = FieldTextarea;
            break;
        default:
            Input = null;
            throw new Error('Unknown input type for CharLimitFieldText');
    }
    const handleChange = React.useCallback((event) => {
        var _a;
        if (countStringChars(event.target.value) <= maxLength) {
            (_a = input.onChange) === null || _a === void 0 ? void 0 : _a.call(input, event);
        }
    }, [input, maxLength]);
    // Unicode-proof way to get string length in codepoints (quick but sub-optimal solution)
    // This can be replaced with the Intl.Segmenter API once it lands in all browsers.
    // example: Array.from(new Intl.Segmenter(locale, {granularity: "grapheme"})).segment(string), data => data.segment)
    const charCount = countStringChars(input.value);
    const charLeft = maxLength - charCount;
    return (_jsxs("div", Object.assign({ style: wrapperStyle }, { children: [Input ? (_jsx(Input, Object.assign({}, props, { input: input, onChange: handleChange, noAlert: true }))) : null, _jsx(FlexBox, Object.assign({ className: styles.charLimitField }, { children: `${charLeft} characters left` }))] })));
}
/*
  It turns out that there's no easy way of counting string length when you have emojis in it.
  An emoji can have multiple code-points which results in "👩‍❤️‍💋‍👩".length === 11
  This issue is not solvable without `Intl.Segmenter` API in browsers which is currently not implemented
  in most browsers. The function below tries is probably the best we have for now.
  @see https: //blog.jonnew.com/posts/poo-dot-length-equals-two
 */
function countStringChars(str) {
    const joiner = '\u{200D}';
    const split = str.split(joiner);
    let count = 0;
    for (const s of split) {
        //removing the variation selectors
        const num = Array.from(s.split(/[\ufe00-\ufe0f]/).join('')).length;
        count += num;
    }
    //assuming the joiners are used appropriately
    return count / split.length;
}
